module.exports = __webpack_public_path__ + "img/tutorial-f06-03.22176ded.png";